import { HTML_LINK_TARGET } from '../../../constants/html'

export function getOpenLinkTooltip({
  openInNewTabButtonProps,
  openLinkTarget,
  t,
}) {
  return (
    openInNewTabButtonProps?.tooltip ??
    (openLinkTarget === HTML_LINK_TARGET.blank
      ? t('Common.LinkTooltipOpenInNewTabKey')
      : undefined)
  )
}
